// Generated by purs version 0.15.15
var UserSpaceOnUse_ = /* #__PURE__ */ (function () {
    function UserSpaceOnUse_() {

    };
    UserSpaceOnUse_.value = new UserSpaceOnUse_();
    return UserSpaceOnUse_;
})();
var ObjectBoundingBox = /* #__PURE__ */ (function () {
    function ObjectBoundingBox() {

    };
    ObjectBoundingBox.value = new ObjectBoundingBox();
    return ObjectBoundingBox;
})();
var showMaskUnit = {
    show: function (v) {
        if (v instanceof UserSpaceOnUse_) {
            return "userSpaceOnUse";
        };
        if (v instanceof ObjectBoundingBox) {
            return "objectBoundingBox";
        };
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.MaskUnit (line 15, column 10 - line 17, column 45): " + [ v.constructor.name ]);
    }
};
var printMaskUnit = function (v) {
    if (v instanceof UserSpaceOnUse_) {
        return "userSpaceOnUse";
    };
    if (v instanceof ObjectBoundingBox) {
        return "objectBoundingBox";
    };
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.MaskUnit (line 23, column 17 - line 25, column 43): " + [ v.constructor.name ]);
};
var eqMaskUnit = {
    eq: function (x) {
        return function (y) {
            if (x instanceof UserSpaceOnUse_ && y instanceof UserSpaceOnUse_) {
                return true;
            };
            if (x instanceof ObjectBoundingBox && y instanceof ObjectBoundingBox) {
                return true;
            };
            return false;
        };
    }
};
export {
    UserSpaceOnUse_,
    ObjectBoundingBox,
    printMaskUnit,
    eqMaskUnit,
    showMaskUnit
};
